import { Route } from "react-router-dom";
import { APP_URLS } from "../../../utils/constant";
import RateAdminRateMirrorsScreen from "../../../container/RateAdminScreen/RateAdminRateMirrorsScreen";
import CreateRateAdminRateMirrors from "../../../container/RateAdminScreen/RateAdminRateMirrorsScreen/CreateRateAdminRateMirrors";

const RateAdminRateMirrorsRoutes = (access = {}) => {
  const { create, view, edit = false } = access;

  return (
    <>
      {!!view && (
        <Route
          path={APP_URLS.RATEADMIN_RATEMIRRORS.HOME}
          element={
            <RateAdminRateMirrorsScreen screenPermissions={access} />
          }
        />
      )}
      {!!create && (
        <Route
          path={APP_URLS.RATEADMIN_RATEMIRRORS.CREATE}
          element={<CreateRateAdminRateMirrors />}
        />
      )}
      {!!edit && (
        <Route
          path={APP_URLS.RATEADMIN_RATEMIRRORS.EDIT}
          element={<CreateRateAdminRateMirrors isEdit={true} />}
        />
      )}
      {(!!create || !!edit) && (
        <Route
          path={APP_URLS.RATEADMIN_RATEMIRRORS.COPY}
          element={<CreateRateAdminRateMirrors isCopy={true} />}
        />
      )}
    </>
  );
};

export default RateAdminRateMirrorsRoutes;
